module.exports = __webpack_public_path__ + "img/header_background.81fad49d.png";